import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Button from '@/components/Button';
import { Container } from '@/components/Layout';
import { HeadingsRow, PageHeading } from '@/components/Layout/Parts';
import Text from '@/components/Text';

import VacationHeader from '../RequestVacation/components/VacationHeader';
import FreelancersInvoicesTable from './components/FreelancersInvoicesTable';

const Holder = styled.div`
  margin-top: 80px;
`;

const StyledHeadingsRow = styled(HeadingsRow)`
  align-items: flex-start;
`;

const FreelancerInvoices = () => {
  return (
    <>
      <VacationHeader />
      <Container $fullScreenModeEnabled={false}>
      <Holder>
        <StyledHeadingsRow>
          <div>
            <Text $type="caption" $color="gray" $isUpperCase>
              Freelancer
            </Text>
            <PageHeading>Invoice List</PageHeading>
          </div>
          <Button as={Link} to="generate">
            Create Invoice
          </Button>
        </StyledHeadingsRow>
        <FreelancersInvoicesTable />
      </Holder>
      </Container>
    </>
  );
};

export default FreelancerInvoices;
